import React from "react";
import logo from "../../components/assets/astra_hack_logo.png";
import { UserAuth } from "../../context/authContext";
import { FiGithub, FiTwitter, FiLinkedin } from "react-icons/fi";
import { Link } from "react-router-dom";

const Footer = () => {
  const { user } = UserAuth();

  return (
    <footer className="relative bg-black/40 pt-16 pb-8 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand Column */}
          <div className="lg:col-span-2 space-y-6">
            <Link to="/" className="block w-48 transition-opacity hover:opacity-80">
              <img src={logo} alt="AstraHack" className="h-auto w-full" />
            </Link>
            <p className="text-text-muted leading-relaxed max-w-sm">
              ASTRAHACK is your go-to for learning blockchain transactions. Dive into interactive
              tools, practice transactions, and resources. Explore blockchain with ease!
            </p>
            <div className="flex items-center gap-4">
              {[
                { icon: FiTwitter, name: "Twitter" },
                { icon: FiGithub, name: "Github" },
                { icon: FiLinkedin, name: "Linkedin" },
              ].map((social) => (
                <button
                  key={social.name}
                  className="w-10 h-10 rounded-full bg-white/5 hover:bg-primary/20 flex items-center justify-center text-text-muted hover:text-primary transition-colors"
                >
                  <span className="sr-only">{social.name}</span>
                  <social.icon className="w-4 h-4" />
                </button>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-white">Quick Links</h3>
            <ul className="space-y-3">
              {[
                { name: "Home", href: "/" },
                { name: "About", href: "#about" },
                { name: "Features", href: "#features" },
                ...(user ? [{ name: "Dashboard", href: "/dashboard" }] : []),
                { name: "FAQ", href: "#faq" },
              ].map((link, idx) => (
                <li key={idx}>
                  {link.href.startsWith("#") ? (
                    <a
                      href={link.href}
                      className="text-text-muted hover:text-primary transition-colors"
                    >
                      {link.name}
                    </a>
                  ) : (
                    <Link
                      to={link.href}
                      className="text-text-muted hover:text-primary transition-colors"
                    >
                      {link.name}
                    </Link>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Legal/Other */}
          <div className="space-y-6">
            <h3 className="text-lg font-bold text-white">Legal</h3>
            <ul className="space-y-3">
              <li>
                <button className="text-text-muted hover:text-white transition-colors">
                  Privacy Policy
                </button>
              </li>
              <li>
                <button className="text-text-muted hover:text-white transition-colors">
                  Terms & Conditions
                </button>
              </li>
            </ul>
          </div>
        </div>

        {/* Footer Bottom */}
        <div className="pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-text-muted">
          <p>© {new Date().getFullYear()} ASTRAHACK. All Rights Reserved.</p>
          <div className="flex items-center gap-6">
            <span>Designed for Hackathons</span>
          </div>
        </div>
      </div>

      {/* Decorative Bottom Image if needed, or remove */}
      {/* <div className="absolute bottom-0 right-0 pointer-events-none opacity-20">
          <img src="assets/images/resource/footer-b.png" alt="" />
      </div> */}
    </footer>
  );
};

export default Footer;
